<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-btn to="/reporting/compliance/summary" rounded>Nutrition</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn to="/reporting/engagement/coaching" rounded>Coaching</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn to="/reporting/corporate/summary" rounded>Corporate</v-btn>
      </v-col>
      <v-col cols="12">
        <h2 class="d-flex justify-center">Overall Engagement</h2>
      </v-col>

      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="3">
            <v-menu
              ref="menu1"
              v-model="menu1"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3">
            <v-menu
              ref="menu2"
              v-model="menu2"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="endDate"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col v-if="gymBranches && gymBranches.length > 0" cols="3">
            <v-select
              v-model="selectedGymBranch"
              item-text="title"
              item-value="id"
              :items="[{ id: null, title: '- Select -' }, ...gymBranches]"
              label="Gym Branches"
            ></v-select>
          </v-col>
          <v-col v-if="teams" cols="3">
            <v-select
              v-model="selectedTeam"
              item-text="name"
              item-value="id"
              :items="[{ id: null, name: '- Select -' }, ...teams]"
              label="Teams"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="selectedTeam" cols="12">
        <team-engagement
          :start-date="startDate"
          :end-date="endDate"
          :gym-branch="selectedGymBranch"
          :team="selectedTeam"
        />
      </v-col>
      <v-col v-if="!selectedTeam" cols="12">
        <daily-active-users :start-date="startDate" :end-date="endDate" :gym-branch="selectedGymBranch" />
      </v-col>
      <v-col v-if="!selectedTeam" cols="12">
        <new-users-report :start-date="startDate" :end-date="endDate" :gym-branch="selectedGymBranch" />
      </v-col>
      <v-col v-if="!selectedTeam" cols="12">
        <dots-logged :start-date="startDate" :end-date="endDate" :gym-branch="selectedGymBranch" />
      </v-col>
      <v-col v-if="!selectedTeam" cols="12">
        <social-actions :start-date="startDate" :end-date="endDate" :gym-branch="selectedGymBranch" />
      </v-col>
      <v-col v-if="!selectedTeam" cols="12">
        <product-activity :start-date="startDate" :end-date="endDate" :gym-branch="selectedGymBranch" />
      </v-col>

      <v-col v-if="!selectedTeam" cols="12">
        <h2>Event Activity by Instructor</h2>
        <v-data-table
          :headers="eventActivityHeaders"
          :items="eventActivityItems"
          :items-per-page="100"
          dense
          class="mt-2 elevation-2"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DailyActiveUsers from "@/components/reporting/blocks/DailyActiveUsers";
import NewUsersReport from "@/components/reporting/blocks/NewUsersReport";
import ProductActivity from "@/components/reporting/blocks/ProductActivity";
import DotsLogged from "@/components/reporting/blocks/DotsLogged";
import SocialActions from "@/components/reporting/blocks/SocialActions";
import TeamEngagement from "@/components/reporting/blocks/TeamEngagement";
import { GYM_BRANCHES_QUERY } from "@/graphql/queries/gym.js";
import { TEAMS_QUERY } from "@/graphql/queries/coaching";
import { EVENT_ACTIVITIY_BY_INSTRUCTOR_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "EngagementSummary",
  components: {
    DailyActiveUsers,
    ProductActivity,
    NewUsersReport,
    DotsLogged,
    SocialActions,
    TeamEngagement,
  },
  data() {
    return {
      eventActivityItems: [],
      eventActivityHeaders: [
        { text: "Event", value: "event" },
        { text: "Instructor", value: "instructor" },
        { text: "Category", value: "category" },
        { text: "Scheduled Date", value: "date" },
        { text: "Activity Count", value: "activity_count" },
        { text: "View Count", value: "view_count" },
      ],
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
      selectedGymBranch: null,
      selectedTeam: null,
    };
  },
  apollo: {
    gymBranches: {
      query: GYM_BRANCHES_QUERY,
    },
    teams: {
      query: TEAMS_QUERY,
    },
    eventActivityByInstructor: {
      query: EVENT_ACTIVITIY_BY_INSTRUCTOR_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.eventActivityItems = response.data.eventActivityByInstructor.map((item) => {
            return {
              event: item.event?.name,
              instructor: item.event?.instructor?.firstName + " " + item.event?.instructor?.lastName,
              category: item.event?.category,
              date: this.$moment(item.event?.scheduledDate).format("YYYY-MM-DD HH:mm"),
              activity_count: item.activityCount,
              view_count: item.viewCount,
            };
          });
        }
      },
    },
  },
};
</script>
